import { Pagination } from "react-bootstrap";

const CustomPagination = ({
    currentPage,
    totalPages,
    onPageChange,
}) => {

    const renderPageNumbers = () => {
        const pages = [];
        pages.push(
            <Pagination.Item
                key={1}
                active={currentPage === 1}
                onClick={() => onPageChange(1)}
            >
                1
            </Pagination.Item>
        );
        if (currentPage > 3) {
            pages.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
        }
        for (let page = currentPage - 1; page <= currentPage + 1; page++) {
            if (page > 1 && page < totalPages) {
                pages.push(
                    <Pagination.Item
                        key={page}
                        active={currentPage === page}
                        onClick={() => onPageChange(page)}
                    >
                        {page}
                    </Pagination.Item>
                );
            }
        }
        if (currentPage < totalPages - 2) {
            pages.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
        }
        if (totalPages > 1) {
            pages.push(
                <Pagination.Item
                    key={totalPages}
                    active={currentPage === totalPages}
                    onClick={() => onPageChange(totalPages)}
                >
                    {totalPages}
                </Pagination.Item>
            );
        }

        return pages;
    };

    return (
        <div className="paginationmain">
            <Pagination>
                <Pagination.Prev
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg" className="arrow">
                        <path d="M0.137597 5.0194L4.35635 9.23815C4.4443 9.32611 4.5636 9.37552 4.68799 9.37552C4.81238 9.37552 4.93167 9.32611 5.01963 9.23815C5.10759 9.1502 5.157 9.0309 5.157 8.90651C5.157 8.78212 5.10759 8.66283 5.01963 8.57487L1.60068 5.15651L10.7817 5.15651C10.9061 5.15651 11.0253 5.10713 11.1132 5.01922C11.2011 4.93131 11.2505 4.81208 11.2505 4.68776C11.2505 4.56344 11.2011 4.44421 11.1132 4.3563C11.0253 4.2684 10.9061 4.21901 10.7817 4.21901L1.60068 4.21901L5.01963 0.800651C5.10759 0.712694 5.157 0.593399 5.157 0.46901C5.157 0.344621 5.10759 0.225326 5.01963 0.137369C4.93167 0.0494129 4.81238 -5.62838e-07 4.68799 -5.73712e-07C4.5636 -5.84586e-07 4.4443 0.0494129 4.35635 0.137369L0.137597 4.35612C0.0940147 4.39965 0.0594393 4.45135 0.0358501 4.50826C0.012261 4.56516 0.000119759 4.62616 0.000119753 4.68776C0.000119748 4.74936 0.012261 4.81036 0.0358501 4.86726C0.0594392 4.92417 0.0940147 4.97587 0.137597 5.0194Z" fill="#494949" />
                    </svg>
                </Pagination.Prev>

                {renderPageNumbers()}

                <Pagination.Next
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                >
                    <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg" className="arrow">
                        <path d="M11.1129 4.35612L6.89414 0.137367C6.80618 0.0494103 6.68689 -3.37512e-06 6.5625 -3.37512e-06C6.43811 -3.37512e-06 6.31882 0.0494103 6.23086 0.137367C6.1429 0.225323 6.09349 0.344618 6.09349 0.469008C6.09349 0.593397 6.1429 0.712692 6.23086 0.800649L9.6498 4.21901H0.46875C0.34443 4.21901 0.225201 4.26839 0.137294 4.3563C0.0493861 4.44421 0 4.56344 0 4.68776C0 4.81208 0.0493861 4.93131 0.137294 5.01921C0.225201 5.10712 0.34443 5.15651 0.46875 5.15651H9.6498L6.23086 8.57487C6.1429 8.66282 6.09349 8.78212 6.09349 8.90651C6.09349 9.0309 6.1429 9.15019 6.23086 9.23815C6.31882 9.32611 6.43811 9.37552 6.5625 9.37552C6.68689 9.37552 6.80618 9.32611 6.89414 9.23815L11.1129 5.0194C11.1565 4.97586 11.191 4.92417 11.2146 4.86726C11.2382 4.81036 11.2504 4.74936 11.2504 4.68776C11.2504 4.62616 11.2382 4.56516 11.2146 4.50825C11.191 4.45135 11.1565 4.39965 11.1129 4.35612Z" fill="#494949" />
                    </svg>
                </Pagination.Next>
            </Pagination>
        </div>
    );
};

export default CustomPagination;
